import { render, staticRenderFns } from "./UploadSelectorModal.vue?vue&type=template&id=4bbeb2f3&scoped=true"
import script from "./UploadSelectorModal.vue?vue&type=script&lang=js"
export * from "./UploadSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./UploadSelectorModal.vue?vue&type=style&index=0&id=4bbeb2f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbeb2f3",
  null
  
)

export default component.exports